import { createContext, useReducer } from "react";
import { Reducer } from "../reducer/Reducer";

export const ExchangeContext = createContext();

const initialState = {

};

export const ExchangeProvider = ({ children }) => {
  const [value, dispatch] = useReducer(Reducer, initialState);

 
  // value.setFieldArr = () => {
  //   dispatch({ type: "setFieldArr"});
  // };

  return (<ExchangeContext.Provider value={value}>{children}</ExchangeContext.Provider>);
};
